import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DolarService {


  constructor(private http: HttpClient) {}

  getDolarBlue(): Observable<any> {
    return this.http.get('https://dolarapi.com/v1/dolares/blue')
  }

  // Dólar blue para uso interno en /admin (a pedido de Nico, 2026-09-14,
  // ajustado a +10 el mismo día): dolarapi + $10 fijo, A PROPÓSITO
  // distinto del que ve el público en el
  // catálogo (ese usa su propio recargo — ver RECARGO_DOLAR en
  // app.component.ts y el config de Configuraciones!B3 para /cotizar).
  // No tocar getDolarBlue() de arriba: la usan cotizar/listado/header
  // público también, cambiarla ahí filtraría este recargo al catálogo.
  getDolarBlueAdmin(): Observable<{ compra: number; venta: number; fechaActualizacion: string }> {
    const RECARGO_ADMIN = 10;
    return this.getDolarBlue().pipe(
      map((d: any) => ({
        compra: Number(d?.compra) + RECARGO_ADMIN,
        venta: Number(d?.venta) + RECARGO_ADMIN,
        fechaActualizacion: d?.fechaActualizacion,
      })),
    );
  }

  // Cotización con la que el CRM vende en pesos: dólar blue "venta" + 15,
  // la misma que publica el sitio (ver `cotizacion-publica.ts` y el header
  // público). No usar el +10 interno de `getDolarBlueAdmin` para una venta:
  // esa referencia es solo para el tablero del admin.
  getCotizacionVenta(): Observable<number> {
    const RECARGO_VENTA = 15;
    return this.getDolarBlue().pipe(
      map((d: any) => Number(d?.venta) + RECARGO_VENTA),
    );
  }

  // Dólar cripto (a pedido de Nico, inspirado en CocosCRM/ReventApp) —
  // dolarapi.com YA expone esta cotización (casa='cripto', promedio de
  // exchanges/P2P), no hace falta ninguna integración nueva con Binance.
  getDolarCripto(): Observable<any> {
    return this.http.get('https://dolarapi.com/v1/dolares/cripto');
  }
}
